import React, { useEffect, useState } from "react";
import "./style.css";
import { Button, Collapse, Input, message } from "antd";
import {
  getUsersList,
  passwordReset,
  searchUser,
} from "../../../API/Company/user";
import { ClipLoader } from "react-spinners";
import { SearchOutlined, UserOutlined, CloseCircleOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

const Security = () => {
  const [newPassword, setNewPassword] = useState("");
  const [retypePassword, setRetypePassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [users, setUsers] = useState();
  const [query, setQuery] = useState("");
  const [activeKey, setActiveKey] = useState(null);

  const handleSavePasswordClick = async (id) => {
    if (newPassword !== retypePassword) {
      message.error("The new passwords do not match. Please try again.");
    } else {
      try {
        setLoadingButton(true);
        const response = await passwordReset(id, newPassword);
        if (response?.data?.message) {
          message.success(response?.data?.message);
        }
        setNewPassword("");
        setRetypePassword("");
        setLoadingButton(false);
      } catch (error) {
        console.error("Error fetching users:", error);
        setLoadingButton(false);
      }
    }
    setNewPassword("");
    setRetypePassword("");
  };

  const checkUserStatus = (status) => {
    if (status === "Active") {
      return true;
    } else {
      return false;
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getUsersList();
      setUsers(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = async () => {
    if (query.trim()) {
      setLoading(true);
      const response = await searchUser(query);
      setUsers(response?.data);
      setLoading(false);
    } else {
      message.error("Please enter a search query");
      setLoading(false);
    }
    setLoading(false);
  };
  const handleResetClick = (userId, key) => {
    if (activeKey === key) {
      setActiveKey(null);
    } else {
      setActiveKey(key);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="loader-container"
      >
        <ClipLoader size={50} color={"#123abc"} loading={loading} />
      </div>
    );
  }

  return (
    <>
      <div className="security-company">
        <div className="header-row">
          <div className="title-group">
            <div className="title">Passwords</div>
            <div className="title-description">
              {new Date().toLocaleDateString("en-US", {
                weekday: "long",
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
            </div>
          </div>

          <div className="search-bar">
            <Input
              className="input-user"
              placeholder="Search User..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              prefix={<SearchOutlined className="input-icon" />}
              suffix={
                query && (
                  <CloseCircleOutlined
                    style={{ cursor: "pointer", color: "#999" }}
                    onClick={() => {
                      setQuery("");
                      fetchData();
                    }}
                  />
                )
              }
              onPressEnter={handleSearch}
            />
          </div>
        </div>
        <div className="user-container">
          <Collapse
            bordered={false}
            activeKey={activeKey}
            expandIconPosition="right"
            accordion
            onChange={(key) => setActiveKey(key)}
          >
            {users?.map((user, index) => (
              <Panel
                header={
                  <>
                    {" "}
                    <div
                      onClick={(e) => e.stopPropagation()}
                      className="User-information"
                    >
                      <div className="Info-content">
                        <div className="profile-text">Team</div>

                        <div className="profile-info">
                          <div className="compact-avatar">
                            {user?.profile_picture ?
                              <img className="profile-pic" src={user?.profile_picture} alt="user-icon" /> :
                              <UserOutlined className="profile-pic" />
                            }
                          </div>

                          <div className="profile-details">
                            <div className="profile-name">{user?.name}</div>
                            <div className="profile-email">{user?.email}</div>
                          </div>
                        </div>
                      </div>
                      <div className="profile-actions">
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleResetClick(user?.id, index.toString());
                          }}
                          className="custom-reset-btn"
                        >
                          Reset Password
                        </Button>
                        <div
                          className={`custom-status-btn ${checkUserStatus(user?.status)
                              ? "active"
                              : "inactive"
                            }`}
                        >
                          {checkUserStatus(user?.status)
                            ? "Active"
                            : "Inactive"}
                        </div>
                      </div>
                    </div>
                  </>
                }
                key={index}
                className="panel-style"
              >
                <div className="password-fields">
                  <div className="password-field">
                    <label htmlFor="new-password">New Password</label>
                    <Input.Password
                      id="new-password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>
                  <div className="password-field">
                    <label htmlFor="retype-new-password">
                      Retype New Password
                    </label>
                    <Input.Password
                      id="retype-new-password"
                      value={retypePassword}
                      onChange={(e) => setRetypePassword(e.target.value)}
                    />
                  </div>
                  <Button
                    className="save-password-button"
                    onClick={() => handleSavePasswordClick(user?.id)}
                    loading={loadingButton}
                  >
                    Save Password
                  </Button>
                </div>
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </>
  );
};

export default Security;
